import { render, staticRenderFns } from "./ClaimableTickets.vue?vue&type=template&id=96c0219c&scoped=true&"
import script from "./ClaimableTickets.vue?vue&type=script&lang=js&"
export * from "./ClaimableTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c0219c",
  null
  
)

export default component.exports